// extracted by css-extract-rspack-plugin
export default {"container":"_a9641594","link":"_f7195f13"};